// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaDownload, FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { BsThreeDots } from "react-icons/bs";
// import { MdAirplanemodeInactive, MdAirplanemodeActive } from "react-icons/md";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function AllLoanList() {
//   const navigate = useNavigate();
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showResponseModal, setShowResponseModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [currentLeadId, setCurrentLeadId] = useState(null);
//   const [leadToDeleteId, setLeadToDeleteId] = useState(null);
//   const [response, setResponse] = useState("");
//   const [responseError, setResponseError] = useState("");
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [categoriesList, setCategoriesList] = useState([]);
//   const [servicesList, setServicesList] = useState([]);
//   const [documentFile, setDocumentFile] = useState([]);
//   const [userId, setUserId] = useState(null);
//   const [orderId, setOrderId] = useState(null);
//   const [exporting, setExporting] = useState(false);
//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     customer_name: "",
//     mobile: "",
//     category: "",
//     service: "",
//     income_source: "",
//     adhar_number: "",
//     pan_card_number: "",
//     state: "",
//     city: "",
//     monthly_income: "",
//     monthly_emi: "",
//     cibil_score: "",
//     cibil_score_value: "",
//     require_loan_amount: "",
//     pincode: "",
//     location: "",
//     pan_card_image: "",
//     adhar_front_image: "",
//     adhar_back_image: "",
//     current_residence_proof: "",
//     permanent_address_proof: "",
//     employeeProof_bussinessRegistration: "",
//     bank_statement: "",
//     bank_statement_current_account: "",
//     gst_return: "",
//     property_paper: "",
//     salary_slip: "",
//     itr: "",
//     form16: "",
//   });

//   const [editFiles, setEditFiles] = useState({});
//   const [errors, setErrors] = useState({});

//   const [searchTerm, setSearchTerm] = useState({
//     name: "",
//     orderid: "",
//     mobile: "",
//     category: "",
//     service: "",
//   });
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const getAuthToken = () => localStorage.getItem("token");

//   const showCustomMessageModal = (title, text, type) => {
//     setMessageModalContent({ title, text, type });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//   };

//   const allowedDomains = [
//     "admin.rajasthanirealestates.in",
//     "realestateadmin.a2logicgroup.com",
//     "master.bahikhatas.com"
//   ];

//   const dontallowedDomains = ["master.bahikhatas.com"];

//   const currentDomain = window.location.host;

//   useEffect(() => {
//     const fetchStates = async () => {
//       try {
//         const token = getAuthToken();
//         if (!token) return;
//         const response = await fetch(`${API_URL}/state-list`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch states.");
//         }
//         const data = await response.json();
//         setStates(data.data || []);
//       } catch (err) {
//         console.error("Fetch states error:", err);
//       }
//     };

//     fetchStates();
//   }, []);

//   useEffect(() => {
//     const fetchCities = async () => {
//       if (editFormData.state) {
//         try {
//           const token = getAuthToken();
//           if (!token) return;
//           const response = await fetch(`${API_URL}/city-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ state_id: editFormData.state }),
//           });
//           if (!response.ok) {
//             throw new Error("Failed to fetch cities.");
//           }
//           const data = await response.json();
//           setCities(data.data || []);
//         } catch (err) {
//           console.error("Fetch cities error:", err);
//         }
//       } else {
//         setCities([]);
//         setEditFormData((prevData) => ({ ...prevData, city: "" }));
//       }
//     };
//     fetchCities();
//   }, [editFormData.state]);

//   useEffect(() => {
//     const fetchCategoriesAndServices = async () => {
//       const token = getAuthToken();
//       if (!token) {
//         console.error("No authentication token found.");
//         return;
//       }

//       try {
//         const categoriesResponse = await fetch(
//           `${API_URL}/loan-lead-category-list`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           },
//         );
//         const categoriesData = await categoriesResponse.json();
//         if (categoriesData.status === "1") {
//           setCategoriesList(categoriesData.data);
//         } else {
//           console.error("Failed to fetch categories:", categoriesData.message);
//         }

//         const servicesResponse = await fetch(
//           `${API_URL}/loan-lead-service-list`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           },
//         );
//         const servicesData = await servicesResponse.json();
//         if (servicesData.status === "1") {
//           setServicesList(servicesData.data);
//         } else {
//           console.error("Failed to fetch services:", servicesData.message);
//         }
//       } catch (error) {
//         console.error("Error fetching categories or services:", error);
//       }
//     };

//     fetchCategoriesAndServices();
//   }, []);

//   const fetchLeads = async (page = 1, search = "") => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Authentication token not found.");

//       const query = new URLSearchParams({
//         page,
//         name: searchTerm.name,
//         orderid: searchTerm.orderid,
//         mobile: searchTerm.mobile,
//         category: searchTerm.category,
//         service: searchTerm.service,
//       }).toString();

//       const response = await fetch(`${API_URL}/loan-lead-list?${query}`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (!response.ok) throw new Error("Failed to fetch leads.");

//       const result = await response.json();
//       setLeads(result.data);
//       const createrIds = result.data.map((item) => item.creater_id);
//       const validIds = createrIds.filter((id) => id != null);
//       const firstId = validIds.length > 0 ? validIds[0] : null;
//       setUserId(firstId);

//       setTotalPages(result.totalPages || 1);
//       setCurrentPage(result.currentPage || page);
//     } catch (error) {
//       console.error("Error fetching loan leads:", error);
//       showCustomMessageModal("Error", "Failed to fetch loan leads.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSingleLead = async (id) => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/loan-lead-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });
//       if (!response.ok) throw new Error("Failed to fetch lead details.");
//       const data = await response.json();
//       return data.data;
//     } catch (error) {
//       console.error("Error fetching single lead:", error);
//       showCustomMessageModal("Error", "Failed to fetch lead details.", "error");
//       return null;
//     }
//   };

//   useEffect(() => {
//     fetchLeads();
//   }, []);

//   const handlePageChange = (pageNumber) => fetchLeads(pageNumber, searchQuery);
//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchLeads(1, searchQuery);
//   };

//   const handleShowResponseModal = (leadId, orderId) => {
//     setCurrentLeadId(leadId);
//     setOrderId(orderId);
//     setShowResponseModal(true);
//   };

//   const handleViewLead = async (id) => {
//     const leadData = await fetchSingleLead(id);
//     if (leadData) {
//       setSelectedLead(leadData);
//       setShowViewModal(true);
//     }
//   };

//   const handleEditLead = async (id) => {
//     const leadData = await fetchSingleLead(id);
//     if (leadData) {
//       setEditFormData({
//         id: leadData.id,
//         customer_name: leadData.customer_name,
//         mobile: leadData.mobile,
//         category: leadData.category,
//         service: leadData.service,
//         income_source: leadData.income_source,
//         adhar_number: leadData.adhar_number,
//         pan_card_number: leadData.pan_card_number,
//         state: leadData.state,
//         city: leadData.city,
//         monthly_income: leadData.monthly_income,
//         monthly_emi: leadData.monthly_emi,
//         cibil_score: leadData.cibil_score,
//         cibil_score_value: leadData.cibil_score_value,
//         require_loan_amount: leadData.require_loan_amount,
//         pincode: leadData.pincode,
//         location: leadData.location,
//         pan_card_image: leadData.pan_card_image || "",
//         adhar_front_image: leadData.adhar_front_image || "",
//         adhar_back_image: leadData.adhar_back_image || "",
//         current_residence_proof: leadData.current_residence_proof || "",
//         permanent_address_proof: leadData.permanent_address_proof || "",
//         employeeProof_bussinessRegistration:
//           leadData.employeeProof_bussinessRegistration || "",
//         bank_statement: leadData.bank_statement || "",
//         bank_statement_current_account:
//           leadData.bank_statement_current_account || "",
//         gst_return: leadData.gst_return || "",
//         property_paper: leadData.property_paper || "",
//         salary_slip: leadData.salary_slip || "",
//         itr: leadData.itr || "",
//         form16: leadData.form16 || "",
//       });
//       setShowEditModal(true);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleEditFileChange = (e) => {
//     const { name, files } = e.target;
//     setEditFiles((prev) => ({ ...prev, [name]: files[0] }));
//   };

//   const [validationErrors, setValidationErrors] = useState({
//     category: "",
//     service: "",
//     plot_id: "",
//     customer_name: "",
//     mobile: "",
//     income_source: "",
//     adhar_number: "",
//     state: "",
//     city: "",
//     monthly_income: "",
//     require_loan_amount: "",
//     pincode: "",
//   });

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!editFormData.customer_name) {
//       errors.customer_name = "Customer name is required";
//       isValid = false;
//     }

//     if (!editFormData.mobile) {
//       errors.mobile = "Mobile number is required";
//       isValid = false;
//     } else if (!/^\d{10}$/.test(editFormData.mobile)) {
//       errors.mobile = "Mobile number must be 10 digits";
//       isValid = false;
//     }

//     if (
//       editFormData.adhar_number &&
//       !/^\d{12}$/.test(editFormData.adhar_number)
//     ) {
//       errors.adhar_number = "Aadhar number must be 12 digits";
//       isValid = false;
//     }

//     if (
//       editFormData.pan_card_number &&
//       !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(editFormData.pan_card_number)
//     ) {
//       errors.pan_card_number = "Invalid PAN card format";
//       isValid = false;
//     }

//     if (editFormData.monthly_income && isNaN(editFormData.monthly_income)) {
//       errors.monthly_income = "Monthly income must be a number";
//       isValid = false;
//     }

//     if (
//       editFormData.require_loan_amount &&
//       isNaN(editFormData.require_loan_amount)
//     ) {
//       errors.require_loan_amount = "Loan amount must be a number";
//       isValid = false;
//     }

//     if (editFormData.pincode && !/^\d{6}$/.test(editFormData.pincode)) {
//       errors.pincode = "Pincode must be 6 digits";
//       isValid = false;
//     }

//     setValidationErrors(errors);
//     return isValid;
//   };

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     if (!editFormData.customer_name || !editFormData.mobile) {
//       setErrors({ customer_name: "Required", mobile: "Required" });
//       return;
//     }

//     try {
//       const token = getAuthToken();
//       const formPayload = new FormData();
//       Object.keys(editFormData).forEach((key) => {
//         formPayload.append(key, editFormData[key]);
//       });
//       Object.keys(editFiles).forEach((key) => {
//         formPayload.append(key, editFiles[key]);
//       });

//       const response = await fetch(`${API_URL}/loan-lead-update`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formPayload,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update project.");
//       }

//       const result = await response.json();

//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           "Lead updated successfully!",
//           "success",
//         );
//         setShowEditModal(false);
//         fetchLeads(currentPage, searchQuery);
//       }
//     } catch (error) {
//       console.error("Error updating lead:", error);
//       showCustomMessageModal("Error", "Failed to update lead.", "error");
//     }
//   };

//   const handleResponseSubmit = async (e) => {
//     e.preventDefault();
//     if (!response.trim()) {
//       setResponseError("Response cannot be empty.");
//       return;
//     }
//     try {
//       const token = getAuthToken();
//       const formData = new FormData();
//       formData.append("lead_id", currentLeadId);
//       formData.append("response", response);
//       documentFile.forEach((file) => {
//         formData.append("documents", file);
//       });

//       const res = await fetch(`${API_URL}/loan-lead-response-store`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!res.ok) throw new Error("Failed to store response.");
//       setShowResponseModal(false);
//       setResponse("");
//       setResponseError("");
//       fetchLeads(currentPage, searchQuery);
//       showCustomMessageModal(
//         "Success",
//         "Response added successfully!",
//         "success",
//       );

//       if (socket && socket.readyState === WebSocket.OPEN) {
//         const notificationPayload = {
//           user_id: userId,
//           type: "loan_lead",
//           message: `A response has been added for Loan Lead ${currentLeadId}.`,
//           statusremark: null,
//           remark: response,
//           order_id: orderId,
//           action_by: "admin",
//         };
//         socket.send(JSON.stringify(notificationPayload));

//         console.warn("WebSocket dddd", notificationPayload);

//         console.warn("notificationPayload", notificationPayload);
//       }
//     } catch (error) {
//       console.error("Error storing response:", error);
//       showCustomMessageModal("Error", "Failed to add response.", "error");
//     }
//   };

//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const ws = new WebSocket(process.env.REACT_APP_WS_URL);

//     ws.onopen = () => {
//       console.log("WebSocket connection established");
//     };

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         console.log("Message from server:", data);
//       } catch (e) {
//         console.log("Raw message:", event.data);
//       }
//     };

//     ws.onclose = () => {
//       console.log("WebSocket disconnected");
//     };

//     ws.onerror = (err) => {
//       console.error("WebSocket error:", err);
//     };

//     setSocket(ws);

//     return () => ws.close();
//   }, []);

//   const handleStatusUpdate = async (id, newStatus) => {
//     console.log("Status change initiated:", { id, newStatus });
//     const originalLead = leads.find((lead) => lead.id === id);
//     const originalStatus = originalLead?.status;
//     const orderId = originalLead?.order_id;

//     try {
//       setLeads((prevLeads) =>
//         prevLeads.map((lead) =>
//           lead.id === id ? { ...lead, status: newStatus } : lead,
//         ),
//       );

//       const token = getAuthToken();
//       if (!token) {
//         throw new Error("Authentication token not found");
//       }

//       setLoading(true);
//       console.log("Making API request...");

//       const response = await fetch(`${API_URL}/loan-lead-update-status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id, status: newStatus }),
//       });

//       console.log("API response status:", response.status);

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update lead status");
//       }

//       const result = await response.json();
//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           result.message || "Lead status updated successfully",
//           "success",
//         );
//         fetchLeads(currentPage, searchQuery);

//         if (socket && socket.readyState === WebSocket.OPEN) {
//           const notificationPayload = {
//             user_id: userId,
//             type: "loan_lead",
//             message: `A new loan lead status has been changed.`,
//             statusremark: newStatus,
//             remark: null,
//             order_id: orderId,
//             action_by: "admin",
//           };
//           socket.send(JSON.stringify(notificationPayload));
//           console.log("📡 Notification sent via WebSocket");
//           console.warn("WebSocket", notificationPayload);
//         }
//       } else {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Somthing Went Wrong",
//           "error",
//         );
//       }
//     } catch (err) {
//       console.error("Status update error:", err);

//       setLeads((prevLeads) =>
//         prevLeads.map((lead) =>
//           lead.id === id ? { ...lead, status: originalStatus } : lead,
//         ),
//       );

//       showCustomMessageModal(
//         "Error",
//         err.message || "An error occurred while updating status",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatStatus = (status) => {
//     const statusMap = {
//       new: "New",
//       documentPending: "Document Pending",
//       sanctionInProcess: "Sanction in Process",
//       sanctioned: "Sanctioned",
//       disbursementInProcess: "Disbursement in Process",
//       disbursed: "Disbursed",
//       propertyOriginalDocumentPending: "Property Original Document Pending",
//       rejected: "Rejected",
//       notintersted: "Not intersted",
//     };
//     return statusMap[status] || status;
//   };

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       pending: "bg-warning text-white",
//       inprocess: "bg-info text-white",
//       approved: "bg-success text-white",
//       notInterested: "bg-danger",
//       available: "bg-success text-dark",
//       sold: "bg-danger",
//       new: "bg-warning text-white",
//     };
//     return classes[status] || "bg-secondary";
//   };

//   const handleShowConfirmModal = (leadId) => {
//     setLeadToDeleteId(leadId);
//     setShowConfirmModal(true);
//   };

//   const handleDeleteLead = async () => {
//     try {
//       const token = getAuthToken();
//       const res = await fetch(`${API_URL}/loan-lead-delete/${leadToDeleteId}`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) throw new Error("Failed to delete lead.");
//       setShowConfirmModal(false);
//       fetchLeads(currentPage, searchQuery);
//       showCustomMessageModal(
//         "Success",
//         "Lead deleted successfully!",
//         "success",
//       );
//     } catch (error) {
//       console.error("Error deleting lead:", error);
//       showCustomMessageModal("Error", "Failed to delete lead.", "error");
//     }
//   };

//   const handleRemarkList = (leadId, orderid, userId) => {
//     navigate(`/loan-remarks/${leadId}/${orderid}/${userId}`);
//   };

//   const exportAllToExcel = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Please login!");
//         return;
//       }

//       let url = `${API_URL}/loan-lead-exceldownload`;

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "text/csv",
//         },
//       });

//       if (!response.ok) {
//         alert("Server Error: Unable to download!");
//         return;
//       }

//       const csvData = await response.text();

//       const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", `projects_${Date.now()}.csv`);
//       link.click();
//     } catch (error) {
//       console.error("CSV Export Error:", error);
//       alert("Export Failed! Try again");
//     }
//   };

//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   // return (
//   //   <div className="userlist mt-2">
//   //     <div className="card shadow-sm">
//   //       <div className="card-header">
//   //         <div className="d-flex flex-wrap-mobile gap-2 align-items-center justify-content-between">
//   //           <div className="titlepage">
//   //             <h3>Loan Lead List</h3>
//   //           </div>

//   //           <div className="d-flex gap-2">
//   //               <div className="createnewadmin">
//   //                 <button
//   //                   className="exportexcel btn gap-2 btn-success d-inline-flex align-items-center"
//   //                   onClick={exportAllToExcel}
//   //                   disabled={exporting}
//   //                 >
//   //                   <FaDownload />
//   //                   {exporting ? (
//   //                     <>
//   //                       <span
//   //                         className="spinner-border spinner-border-sm me-2"
//   //                         role="status"
//   //                         aria-hidden="true"
//   //                       ></span>
//   //                       Exporting All...
//   //                     </>
//   //                   ) : (
//   //                     "Export"
//   //                   )}
//   //                 </button>
//   //               </div>
//   //             <Link to="/create-loan" className="btn btn-primary">
//   //               <FaPlus className="me-2" /> Create Lead
//   //             </Link>
//   //             <button
//   //               className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//   //               onClick={handleToggle}
//   //             >
//   //               {isFilterActive ? (
//   //                 <>
//   //                   <MdFilterAltOff />
//   //                 </>
//   //               ) : (
//   //                 <>
//   //                   <MdFilterAlt />
//   //                 </>
//   //               )}
//   //             </button>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       <div className="card-body">
//   //         {isFilterActive && (
//   //           <div className="d-flex gap-2 mb-3 flex-wrap-mobile">
//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="text"
//   //                 name="name"
//   //                 placeholder="Name"
//   //                 value={searchTerm.name}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="text"
//   //                 name="orderid"
//   //                 placeholder="Loan Id"
//   //                 value={searchTerm.orderid}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="number"
//   //                 name="mobile"
//   //                 placeholder="Mobile number"
//   //                 value={searchTerm.mobile}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <select
//   //                 name="category"
//   //                 className=""
//   //                 value={searchTerm.category}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               >
//   //                 <option value="">Category</option>
//   //                 {categoriesList.map((category) => (
//   //                   <option key={category.id} value={category.name}>
//   //                     {category.name}
//   //                   </option>
//   //                 ))}
//   //               </select>
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <select
//   //                 name="service"
//   //                 className=""
//   //                 value={searchTerm.service}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               >
//   //                 <option value="">Service</option>
//   //                 {servicesList.map((service) => (
//   //                   <option key={service.id} value={service.name}>
//   //                     {service.name}
//   //                   </option>
//   //                 ))}
//   //               </select>
//   //             </div>

//   //             <div className="form_design">
//   //               <button
//   //                 type="button"
//   //                 className="submit_button btn text-white"
//   //                 onClick={handleSearch}
//   //               >
//   //                 Search
//   //               </button>
//   //             </div>
//   //           </div>
//   //         )}
//   //         {loading ? (
//   //           <p>Loading leads...</p>
//   //         ) : leads?.length === 0 ? (
//   //           <p className="text-center mt-4">No loan leads found.</p>
//   //         ) : (
//   //           <>
//   //             {/* <Table striped bordered hover responsive>
//   //               <thead>
//   //                 <tr>
//   //                   <th>#</th>
//   //                   <th>Lead ID</th>
//   //                   <th>Customer Name</th>
//   //                   <th>Mobile</th>
//   //                   <th>Category</th>
//   //                   <th>Services</th>
//   //                   <th>Status</th>
//   //                   <th>Lead Date</th>
//   //                   <th>Remark</th>
//   //                   <th>Action</th>
//   //                 </tr>
//   //               </thead>
//   //               <tbody>
//   //                 {leads && leads.map((lead, index) => (
//   //                   <tr key={lead.id}>
//   //                     <td>{index + 1}</td>
//   //                     <td>{lead.order_id}</td>
//   //                     <td>{lead.customer_name}</td>
//   //                     <td>{lead.mobile}</td>
//   //                     <td>{lead.category}</td>
//   //                     <td>{lead.service}</td>
//   //                     <td>
//   //                       <select
//   //                         className={`form-select custum_all_select ${getStatusBadgeClass(lead.status)}`}
//   //                         value={lead.status}
//   //                         onChange={async (e) => {
//   //                           const newStatus = e.target.value;
//   //                           console.log('Select changed to:', newStatus);
//   //                           await handleStatusUpdate(lead.id, newStatus);
//   //                         }}
//   //                         disabled={loading}
//   //                       >
//   //                         {["new", "documentPending", "sanctionInProcess", "sanctioned", "disbursementInProcess", "disbursed", "propertyOriginalDocumentPending"].map((status) => (
//   //                           <option
//   //                             key={status}
//   //                             value={status}
//   //                             className={getStatusBadgeClass(status)}
//   //                           >
//   //                             {formatStatus(status)}
//   //                           </option>
//   //                         ))}
//   //                       </select>
//   //                     </td>
//   //                     <td>{lead.date}</td>
//   //                     <td>
//   //                       <button
//   //                         className="btn bg-success btn-sm me-1 text-white"
//   //                         onClick={() => handleShowResponseModal(lead.id, lead.order_id)}
//   //                         title="Add Response"
//   //                       >
//   //                         Add Remark
//   //                       </button>
//   //                     </td>
//   //                     <td>
//   //                       <div className="dropdown">
//   //                         <button
//   //                           className="btn light btn-action dropdown-toggle"
//   //                           type="button"
//   //                           id={`dropdownMenuButton-${lead.id}`}
//   //                           data-bs-toggle="dropdown"
//   //                           aria-expanded="false"
//   //                         >
//   //                           <BsThreeDots size={20} />
//   //                         </button>
//   //                         <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${lead.id}`}>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn view_btn btn-sm me-1"
//   //                               onClick={() => handleViewLead(lead.id)}
//   //                               title="View Lead Details"
//   //                             >
//   //                               <FaEye className="me-2" /> View
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn edit_btn btn-sm me-1"
//   //                               onClick={() => handleEditLead(lead.id)}
//   //                               title="Edit Loan"
//   //                             >
//   //                               <FaEdit className="me-2" /> Edit
//   //                             </button>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn btn-danger btn-sm"
//   //                               onClick={() => handleRemarkList(lead.id, lead.order_id, userId)}
//   //                               title="Remark Loan Lead"
//   //                             >
//   //                               <FaEdit className="me-2" /> Remark History Loan
//   //                             </button>
//   //                           </li>

//   //                         </ul>
//   //                       </div>
//   //                     </td>
//   //                   </tr>
//   //                 ))}
//   //               </tbody>
//   //             </Table> */}

//   //             <Table striped bordered hover responsive>
//   //               <thead>
//   //                 <tr>
//   //                   <th>#</th>
//   //                   <th>Lead ID</th>
//   //                   <th>Customer Name</th>
//   //                   <th>Mobile</th>
//   //                   <th>Category</th>
//   //                   <th>Services</th>
//   //                   <th>Status</th>
//   //                   <th>Lead Date</th>
//   //                   <th>Remark</th>
//   //                   <th>Action</th>
//   //                 </tr>
//   //               </thead>
//   //               <tbody>
//   //                 {leads &&
//   //                   leads.map((lead, index) => (
//   //                     <tr key={lead.id}>
//   //                       <td>{(currentPage - 1) * 10 + index + 1}</td>
//   //                       <td>{lead.order_id}</td>
//   //                       <td>
//   //                         {lead.customer_name
//   //                           ? lead.customer_name.charAt(0).toUpperCase() +
//   //                             lead.customer_name.slice(1).toLowerCase()
//   //                           : ""}
//   //                       </td>

//   //                       <td>{lead.mobile}</td>
//   //                       <td>
//   //                         {lead.category
//   //                           ? lead.category.charAt(0).toUpperCase() +
//   //                             lead.category.slice(1).toLowerCase()
//   //                           : ""}
//   //                       </td>

//   //                       <td>
//   //                         {lead.service
//   //                           ? lead.service.charAt(0).toUpperCase() +
//   //                             lead.service.slice(1).toLowerCase()
//   //                           : ""}
//   //                       </td>

//   //                       <td>
//   //                         <select
//   //                           className={`form-select custum_all_select ${getStatusBadgeClass(lead.status)}`}
//   //                           value={lead.status}
//   //                           onChange={async (e) => {
//   //                             const newStatus = e.target.value;
//   //                             console.log("Select changed to:", newStatus);
//   //                             await handleStatusUpdate(lead.id, newStatus);
//   //                           }}
//   //                           disabled={loading}
//   //                         >
//   //                           {[
//   //                             "new",
//   //                             "documentPending",
//   //                             "sanctionInProcess",
//   //                             "sanctioned",
//   //                             "disbursementInProcess",
//   //                             "disbursed",
//   //                             "propertyOriginalDocumentPending",
//   //                             "rejected",
//   //                             "notintersted",
//   //                           ].map((status) => (
//   //                             <option
//   //                               key={status}
//   //                               value={status}
//   //                               className={getStatusBadgeClass(status)}
//   //                             >
//   //                               {formatStatus(status)}
//   //                             </option>
//   //                           ))}
//   //                         </select>
//   //                       </td>
//   //                       <td>{lead.date}</td>
//   //                       <td>
//   //                         <button
//   //                           className="btn bg-success btn-sm me-1 text-white"
//   //                           onClick={() =>
//   //                             handleShowResponseModal(lead.id, lead.order_id)
//   //                           }
//   //                           title="Add Response"
//   //                         >
//   //                           Add Remark
//   //                         </button>
//   //                       </td>
//   //                       <td>
//   //                         <div className="dropdown">
//   //                           <button
//   //                             className="btn light btn-action dropdown-toggle"
//   //                             type="button"
//   //                             id={`dropdownMenuButton-${lead.id}`}
//   //                             data-bs-toggle="dropdown"
//   //                             aria-expanded="false"
//   //                           >
//   //                             <BsThreeDots size={20} />
//   //                           </button>
//   //                           <ul
//   //                             className="dropdown-menu"
//   //                             aria-labelledby={`dropdownMenuButton-${lead.id}`}
//   //                           >
//   //                             <li className="dropdown-item">
//   //                               <button
//   //                                 className="btn view_btn btn-sm me-1"
//   //                                 onClick={() => handleViewLead(lead.id)}
//   //                                 title="View Lead Details"
//   //                               >
//   //                                 <FaEye className="me-2" /> View
//   //                               </button>
//   //                             </li>
//   //                             <li className="dropdown-item">
//   //                               <button
//   //                                 className="btn edit_btn btn-sm me-1"
//   //                                 onClick={() => handleEditLead(lead.id)}
//   //                                 title="Edit Loan"
//   //                               >
//   //                                 <FaEdit className="me-2" /> Edit
//   //                               </button>
//   //                             </li>
//   //                             <li className="dropdown-item">
//   //                               <button
//   //                                 className="btn btn-danger btn-sm"
//   //                                 onClick={() =>
//   //                                   handleRemarkList(
//   //                                     lead.id,
//   //                                     lead.order_id,
//   //                                     userId,
//   //                                   )
//   //                                 }
//   //                                 title="Remark Loan Lead"
//   //                               >
//   //                                 <FaEdit className="me-2" /> Remark History
//   //                                 Loan
//   //                               </button>
//   //                             </li>
//   //                           </ul>
//   //                         </div>
//   //                       </td>
//   //                     </tr>
//   //                   ))}
//   //               </tbody>
//   //             </Table>
//   //           </>
//   //         )}
//   //         <div className="d-flex justify-content-end">
//   //           <nav>
//   //             <ul className="pagination">
//   //               <li className="page-item">
//   //                 <button
//   //                   className="page-link"
//   //                   onClick={() => handlePageChange(currentPage - 1)}
//   //                   disabled={currentPage === 1}
//   //                   aria-label="Previous"
//   //                 >
//   //                   <HiOutlineChevronLeft />
//   //                 </button>
//   //               </li>

//   //               {[...Array(totalPages)].map((_, index) => (
//   //                 <li key={index + 1} className="page-item">
//   //                   <button
//   //                     className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
//   //                     onClick={() => handlePageChange(index + 1)}
//   //                   >
//   //                     {index + 1}
//   //                   </button>
//   //                 </li>
//   //               ))}

//   //               <li className="page-item">
//   //                 <button
//   //                   className="page-link"
//   //                   onClick={() => handlePageChange(currentPage + 1)}
//   //                   disabled={currentPage === totalPages}
//   //                   aria-label="Next"
//   //                 >
//   //                   <HiChevronRight />
//   //                 </button>
//   //               </li>
//   //             </ul>
//   //           </nav>
//   //         </div>
//   //       </div>
//   //     </div>

//   //     <Modal
//   //       show={showResponseModal}
//   //       onHide={() => {
//   //         setShowResponseModal(false);
//   //         setDocumentFile([]);
//   //       }}
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Add Remark</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form onSubmit={handleResponseSubmit}>
//   //           <Form.Group controlId="responseTextArea" className="mb-3">
//   //             <Form.Label>Remark Description</Form.Label>
//   //             <Form.Control
//   //               as="textarea"
//   //               rows={3}
//   //               value={response}
//   //               onChange={(e) => setResponse(e.target.value)}
//   //               isInvalid={!!responseError}
//   //             />
//   //             <Form.Control.Feedback type="invalid">
//   //               {responseError}
//   //             </Form.Control.Feedback>
//   //           </Form.Group>

//   //           <Form.Group className="mb-3">
//   //             <Form.Label>Documents</Form.Label>
//   //             <Form.Control
//   //               type="file"
//   //               accept="image/*,.pdf"
//   //               onChange={(e) => setDocumentFile(Array.from(e.target.files))}
//   //               multiple
//   //             />
//   //             {documentFile && documentFile.length > 0 && (
//   //               <div className="mt-2">
//   //                 <small className="text-muted">Selected files:</small>
//   //                 <ul className="list-unstyled">
//   //                   {documentFile.map((file, index) => (
//   //                     <li key={index}>
//   //                       <small>
//   //                         {file.name} ({Math.round(file.size / 1024)} KB)
//   //                       </small>
//   //                     </li>
//   //                   ))}
//   //                 </ul>
//   //               </div>
//   //             )}
//   //           </Form.Group>

//   //           <div className="d-flex justify-content-end mt-3">
//   //             <Button
//   //               variant="danger"
//   //               onClick={() => {
//   //                 setShowResponseModal(false);
//   //                 setDocumentFile([]);
//   //               }}
//   //             >
//   //               Cancel
//   //             </Button>
//   //             <Button
//   //               variant="primary"
//   //               type="submit"
//   //               className="ms-2"
//   //               disabled={!response && documentFile?.length === 0}
//   //             >
//   //               Save Remark
//   //             </Button>
//   //           </div>
//   //         </Form>
//   //       </Modal.Body>
//   //     </Modal>

//   //     {/* View Modal */}
//   //     <Modal
//   //       show={showViewModal}
//   //       onHide={() => setShowViewModal(false)}
//   //       size="lg"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Lead Details</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         {selectedLead && (
//   //           <div className="row">
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Customer Name:</strong> {selectedLead.customer_name}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Mobile:</strong> {selectedLead.mobile}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Category:</strong> {selectedLead.category}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Service:</strong> {selectedLead.service}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Income Source:</strong> {selectedLead.income_source}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Adhar Number:</strong> {selectedLead.adhar_number}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Pan Card Number:</strong> {selectedLead.pan_card_number}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>State:</strong> {selectedLead.state_name}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>City:</strong> {selectedLead.city_name}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Monthly Income:</strong> {selectedLead.monthly_income}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Monthly EMI:</strong> {selectedLead.monthly_emi}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>CIBIL Score:</strong> {selectedLead.cibil_score}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>CIBIL Value:</strong> {selectedLead.cibil_score_value}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Required Loan:</strong>{" "}
//   //               {selectedLead.require_loan_amount}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Pincode:</strong> {selectedLead.pincode}
//   //             </div>
//   //             <div className="col-md-6 mb-3">
//   //               <strong>Location:</strong> {selectedLead.location}
//   //             </div>

//   //             <hr className="my-4" />
//   //             <h5 className="mb-3">Uploaded Documents</h5>
//   //             <div className="row">
//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.adhar_front_image && (
//   //                   <div className="mb-3">
//   //                     <div className="d-flex justify-content-between align-items-center">
//   //                       <strong>Adhar Front:</strong>
//   //                     </div>
//   //                     <img
//   //                       src={`${imageAPIURL}/loanlead/${selectedLead.adhar_front_image}`}
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="img-fluid rounded mt-2"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     />
//   //                     <button
//   //                       className="ms-2 btn btn-primary"
//   //                       onClick={() => {
//   //                         window.open(
//   //                           `${imageAPIURL}/loanlead/${selectedLead.adhar_front_image}`,
//   //                           "_blank",
//   //                         );
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </button>
//   //                   </div>
//   //                 )}
//   //               </div>
//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.adhar_back_image && (
//   //                   <div className="mb-3">
//   //                     <div className="d-flex justify-content-between align-items-center">
//   //                       <strong>Adhar Back:</strong>
//   //                     </div>

//   //                     <img
//   //                       src={`${imageAPIURL}/loanlead/${selectedLead.adhar_back_image}`}
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="img-fluid rounded"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     />
//   //                     <button
//   //                       className="btn btn-primary"
//   //                       onClick={() => {
//   //                         window.open(
//   //                           `${imageAPIURL}/loanlead/${selectedLead.adhar_back_image}`,
//   //                           "_blank",
//   //                         );
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </button>
//   //                   </div>
//   //                 )}
//   //               </div>
//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.pan_card_image && (
//   //                   <div className="mb-3">
//   //                     <div className="d-flex justify-content-between align-items-center">
//   //                       <strong>PAN Card:</strong>
//   //                     </div>

//   //                     <img
//   //                       src={`${imageAPIURL}/loanlead/${selectedLead.pan_card_image}`}
//   //                       alt={`${selectedLead.name} PAN Card`}
//   //                       className="img-fluid rounded"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     />
//   //                     <button
//   //                       className="btn btn-primary"
//   //                       onClick={() => {
//   //                         window.open(
//   //                           `${imageAPIURL}/loanlead/${selectedLead.pan_card_image}`,
//   //                           "_blank",
//   //                         );
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </button>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.current_residence_proof && (
//   //                   <div className="mb-3">
//   //                     <strong>Current Residence Proof:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.current_residence_proof}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.bank_statement && (
//   //                   <div className="mb-3">
//   //                     <strong>Bank Statement:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.bank_statement}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.bank_statement_current_account && (
//   //                   <div className="mb-3">
//   //                     <strong>Bank Statement Current Account:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.bank_statement_current_account}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.gst_return && (
//   //                   <div className="mb-3">
//   //                     <strong>GST Return:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.gst_return}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.property_paper && (
//   //                   <div className="mb-3">
//   //                     <strong>Property Paper:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.property_paper}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.permanent_address_proof && (
//   //                   <div className="mb-3">
//   //                     <strong>Permanent Address Proof:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.permanent_address_proof}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.employeeProof_bussinessRegistration && (
//   //                   <div className="mb-3">
//   //                     <strong>Employee Proof Bussiness Registration:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.employeeProof_bussinessRegistration}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.salary_slip && (
//   //                   <div className="mb-3">
//   //                     <strong>Salary Slip:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.salary_slip}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.form16 && (
//   //                   <div className="mb-3">
//   //                     <strong>Form 16:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.form16}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>

//   //               <div className="col-md-4 mb-3">
//   //                 {selectedLead.itr && (
//   //                   <div className="mb-3">
//   //                     <strong>ITR:</strong>
//   //                     <br />
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${selectedLead.itr}`}
//   //                       download
//   //                       alt={`${selectedLead.name} Main`}
//   //                       className="ms-2 btn btn-primary"
//   //                       style={{
//   //                         maxWidth: "200px",
//   //                         maxHeight: "150px",
//   //                         objectFit: "cover",
//   //                       }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x150/cccccc/000000?text=No+Main+Image";
//   //                       }}
//   //                     >
//   //                       Download
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </div>
//   //             </div>
//   //           </div>
//   //         )}
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="danger" onClick={() => setShowViewModal(false)}>
//   //           Close
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {/* Edit Modal */}
//   //     <Modal
//   //       show={showEditModal}
//   //       onHide={() => setShowEditModal(false)}
//   //       size="lg"
//   //       className="formselectnewdesign"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Loan Lead</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form onSubmit={handleUpdateSubmit}>
//   //           <Row>
//   //             <Col md={12}>
//   //               <div class="card_title_all mb-3">User Details</div>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Customer Name*</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="customer_name"
//   //                   value={editFormData.customer_name}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!errors.customer_name}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {errors.customer_name}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Mobile*</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="mobile"
//   //                   value={editFormData.mobile}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.mobile}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.mobile}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Category</Form.Label>

//   //                 <Form.Control
//   //                   as="select"
//   //                   name="category"
//   //                   value={editFormData.category}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!errors.category}
//   //                 >
//   //                   <option value="">Select Category</option>
//   //                   {categoriesList.map((category) => (
//   //                     <option key={category.id} value={category.name}>
//   //                       {category.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Service</Form.Label>

//   //                 <Form.Control
//   //                   as="select"
//   //                   name="service"
//   //                   value={editFormData.service}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!errors.service}
//   //                 >
//   //                   <option value="">Select Service</option>
//   //                   {servicesList.map((service) => (
//   //                     <option key={service.id} value={service.name}>
//   //                       {service.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Income Source</Form.Label>
//   //                 <Form.Control
//   //                   as="select"
//   //                   name="income_source"
//   //                   value={editFormData.income_source}
//   //                   onChange={handleEditFormChange}
//   //                 >
//   //                   <option value="">Select Income Source</option>
//   //                   <option value="business">Business</option>
//   //                   <option value="salaried">Salaried</option>
//   //                   <option value="rent">Rent</option>
//   //                   <option value="pension">Pension</option>
//   //                   <option value="other">Other</option>
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Adhar Number</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="adhar_number"
//   //                   value={editFormData.adhar_number}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.adhar_number}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.adhar_number}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>PAN Card Number</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="pan_card_number"
//   //                   value={editFormData.pan_card_number}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.pan_card_number}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.pan_card_number}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>State</Form.Label>
//   //                 <Form.Select
//   //                   name="state"
//   //                   value={editFormData.state}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 >
//   //                   <option value="">Select State</option>
//   //                   {states.map((state) => (
//   //                     <option key={state.id} value={String(state.id)}>
//   //                       {state.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Select>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>City</Form.Label>
//   //                 <Form.Select
//   //                   name="city"
//   //                   value={editFormData.city}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                   disabled={!editFormData.state || cities.length === 0}
//   //                 >
//   //                   <option value="">Select City</option>
//   //                   {cities.map((city) => (
//   //                     <option key={city.id} value={city.id}>
//   //                       {city.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Select>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Monthly Income</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="monthly_income"
//   //                   value={editFormData.monthly_income}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.monthly_income}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.monthly_income}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Monthly EMI</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="monthly_emi"
//   //                   value={editFormData.monthly_emi}
//   //                   onChange={handleEditFormChange}
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>CIBIL Score</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="cibil_score"
//   //                   value={editFormData.cibil_score}
//   //                   onChange={handleEditFormChange}
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>CIBIL Score Value</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="cibil_score_value"
//   //                   value={editFormData.cibil_score_value}
//   //                   onChange={handleEditFormChange}
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Required Loan Amount</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="require_loan_amount"
//   //                   value={editFormData.require_loan_amount}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.require_loan_amount}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.require_loan_amount}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative">
//   //                 <Form.Label>Pincode</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="pincode"
//   //                   value={editFormData.pincode}
//   //                   onChange={handleEditFormChange}
//   //                   isInvalid={!!validationErrors.pincode}
//   //                   required
//   //                 />
//   //                 <Form.Control.Feedback type="invalid">
//   //                   {validationErrors.pincode}
//   //                 </Form.Control.Feedback>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative">
//   //                 <Form.Label>Location</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="location"
//   //                   value={editFormData.location}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           {/* File Upload Sections */}

//   //           <Row>
//   //             <Col md={12}>
//   //               <div class="card_title_all mb-3">Document Uploads</div>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Adhar Front Image</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="adhar_front_image"
//   //                   onChange={handleEditFileChange}
//   //                   accept="image/*"
//   //                 />
//   //                 {editFormData.adhar_front_image && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.adhar_front_image}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current Image
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Adhar Back Image</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="adhar_back_image"
//   //                   onChange={handleEditFileChange}
//   //                   accept="image/*"
//   //                 />
//   //                 {editFormData.adhar_back_image && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.adhar_back_image}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current Image
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>PAN Card Image</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="pan_card_image"
//   //                   onChange={handleEditFileChange}
//   //                   accept="image/*"
//   //                 />
//   //                 {editFormData.pan_card_image && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.pan_card_image}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current Image
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Current Residence Proof (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="current_residence_proof"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.current_residence_proof && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.current_residence_proof}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Permanent Address Proof (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="permanent_address_proof"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.permanent_address_proof && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.permanent_address_proof}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>
//   //                   Employee/Business Registration Proof (PDF)
//   //                 </Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="employeeProof_bussinessRegistration"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.employeeProof_bussinessRegistration && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.employeeProof_bussinessRegistration}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Bank Statement (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="bank_statement"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.bank_statement && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.bank_statement}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>
//   //                   Bank Statement - Current Account (PDF)
//   //                 </Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="bank_statement_current_account"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.bank_statement_current_account && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.bank_statement_current_account}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>GST Return (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="gst_return"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.gst_return && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.gst_return}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Property Paper (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="property_paper"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.property_paper && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.property_paper}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Salary Slip (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="salary_slip"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.salary_slip && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.salary_slip}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>ITR (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="itr"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.itr && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.itr}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="position-relative mb-3">
//   //                 <Form.Label>Form 16 (PDF)</Form.Label>
//   //                 <Form.Control
//   //                   type="file"
//   //                   name="form16"
//   //                   onChange={handleEditFileChange}
//   //                   accept=".pdf"
//   //                 />
//   //                 {editFormData.form16 && (
//   //                   <div className="buttonviewallimages">
//   //                     <a
//   //                       href={`${imageAPIURL}/loanlead/${editFormData.form16}`}
//   //                       target="_blank"
//   //                       rel="noopener noreferrer"
//   //                     >
//   //                       View Current PDF
//   //                     </a>
//   //                   </div>
//   //                 )}
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>

//   //           <div className="d-flex justify-content-end mt-3">
//   //             <Button variant="danger" onClick={() => setShowEditModal(false)}>
//   //               Cancel
//   //             </Button>
//   //             <Button variant="primary" type="submit" className="ms-2">
//   //               Save Changes
//   //             </Button>
//   //           </div>
//   //         </Form>
//   //       </Modal.Body>
//   //     </Modal>

//   //     {/* Confirmation Modal for Deletion */}
//   //     <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Confirm Deletion</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         Are you sure you want to delete this lead? This action cannot be
//   //         undone.
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="danger" onClick={() => setShowConfirmModal(false)}>
//   //           Cancel
//   //         </Button>
//   //         <Button variant="danger" onClick={handleDeleteLead}>
//   //           Delete
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {/* Message Modal */}
//   //     <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
//   //       <Modal.Header
//   //         closeButton
//   //         className={`border-top border-4 ${
//   //           messageModalContent.type === "success"
//   //             ? "border-success"
//   //             : messageModalContent.type === "error"
//   //               ? "border-danger"
//   //               : "border-warning"
//   //         }`}
//   //       >
//   //         <Modal.Title
//   //           className={`modal-title ${
//   //             messageModalContent.type === "success"
//   //               ? "text-success"
//   //               : messageModalContent.type === "error"
//   //                 ? "text-danger"
//   //                 : "text-warning"
//   //           }`}
//   //         >
//   //           {messageModalContent.title}
//   //         </Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body className="text-secondary">
//   //         <p>{messageModalContent.text}</p>
//   //       </Modal.Body>
//   //       <Modal.Footer className="justify-content-center">
//   //         <Button
//   //           variant={
//   //             messageModalContent.type === "success"
//   //               ? "success"
//   //               : messageModalContent.type === "error"
//   //                 ? "danger"
//   //                 : "primary"
//   //           }
//   //           onClick={closeCustomMessageModal}
//   //         >
//   //           OK
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>
//   //   </div>
//   // );

//     return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📋
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Loan Lead List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all your loan leads in one place
//               </p>
//             </div>

//             <div className="d-flex gap-2 flex-wrap">
//               <button
//                 className="exportexcel btn gap-2 btn-success d-inline-flex align-items-center"
//                 onClick={exportAllToExcel}
//                 disabled={exporting}
//               >
//                 <FaDownload />
//                 {exporting ? (
//                   <>
//                     <span
//                       className="spinner-border spinner-border-sm me-2"
//                       role="status"
//                       aria-hidden="true"
//                     ></span>
//                     Exporting...
//                   </>
//                 ) : (
//                   "Export"
//                 )}
//               </button>

//               <Link to="/create-loan" className="btn btn-primary">
//                 <FaPlus className="me-2" /> Create Lead
//               </Link>

//               <button
//                 className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTERS */}
//               {isFilterActive && (
//                 <div className="d-flex gap-2 mb-3 flex-wrap-mobile">
//                   <div className="form_design w-100">
//                     <input
//                       type="text"
//                       name="name"
//                       placeholder="Name"
//                       value={searchTerm.name}
//                       onChange={(e) =>
//                         setSearchTerm({
//                           ...searchTerm,
//                           [e.target.name]: e.target.value,
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="form_design w-100">
//                     <input
//                       type="text"
//                       name="orderid"
//                       placeholder="Loan Id"
//                       value={searchTerm.orderid}
//                       onChange={(e) =>
//                         setSearchTerm({
//                           ...searchTerm,
//                           [e.target.name]: e.target.value,
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="form_design w-100">
//                     <input
//                       type="number"
//                       name="mobile"
//                       placeholder="Mobile number"
//                       value={searchTerm.mobile}
//                       onChange={(e) =>
//                         setSearchTerm({
//                           ...searchTerm,
//                           [e.target.name]: e.target.value,
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="form_design w-100">
//                     <select
//                       name="category"
//                       value={searchTerm.category}
//                       onChange={(e) =>
//                         setSearchTerm({
//                           ...searchTerm,
//                           [e.target.name]: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Category</option>
//                       {categoriesList.map((category) => (
//                         <option key={category.id} value={category.name}>
//                           {category.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="form_design w-100">
//                     <select
//                       name="service"
//                       value={searchTerm.service}
//                       onChange={(e) =>
//                         setSearchTerm({
//                           ...searchTerm,
//                           [e.target.name]: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Service</option>
//                       {servicesList.map((service) => (
//                         <option key={service.id} value={service.name}>
//                           {service.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="form_design">
//                     <button
//                       type="button"
//                       className="submit_button btn text-white"
//                       onClick={handleSearch}
//                     >
//                       Search
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* TABLE */}
//               {loading ? (
//                 <p>Loading leads...</p>
//               ) : leads?.length === 0 ? (
//                 <p className="text-center mt-4">No loan leads found.</p>
//               ) : (
//                 <Table striped bordered hover responsive>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Lead ID</th>
//                       <th>Customer Name</th>
//                       <th>Mobile</th>
//                       <th>Category</th>
//                       <th>Services</th>
//                       <th>Status</th>
//                       <th>Lead Date</th>
//                       <th>Remark</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {leads.map((lead, index) => (
//                       <tr key={lead.id}>
//                         <td>{(currentPage - 1) * 10 + index + 1}</td>
//                         <td>{lead.order_id}</td>
//                         <td>
//                           {lead.customer_name
//                             ? lead.customer_name.charAt(0).toUpperCase() +
//                               lead.customer_name.slice(1).toLowerCase()
//                             : ""}
//                         </td>
//                         <td>{lead.mobile}</td>
//                         <td>
//                           {lead.category
//                             ? lead.category.charAt(0).toUpperCase() +
//                               lead.category.slice(1).toLowerCase()
//                             : ""}
//                         </td>
//                         <td>
//                           {lead.service
//                             ? lead.service.charAt(0).toUpperCase() +
//                               lead.service.slice(1).toLowerCase()
//                             : ""}
//                         </td>
//                         <td>
//                           <select
//                             className={`form-select custum_all_select ${getStatusBadgeClass(lead.status)}`}
//                             value={lead.status}
//                             onChange={async (e) => {
//                               await handleStatusUpdate(lead.id, e.target.value);
//                             }}
//                             disabled={loading}
//                           >
//                             {[
//                               "new",
//                               "documentPending",
//                               "sanctionInProcess",
//                               "sanctioned",
//                               "disbursementInProcess",
//                               "disbursed",
//                               "propertyOriginalDocumentPending",
//                               "rejected",
//                               "notintersted",
//                             ].map((status) => (
//                               <option key={status} value={status}>
//                                 {formatStatus(status)}
//                               </option>
//                             ))}
//                           </select>
//                         </td>
//                         <td>{lead.date}</td>
//                         <td>
//                           <button
//                             className="btn bg-success btn-sm me-1 text-white"
//                             onClick={() =>
//                               handleShowResponseModal(lead.id, lead.order_id)
//                             }
//                           >
//                             Add Remark
//                           </button>
//                         </td>
//                         <td>
//                           <div className="dropdown">
//                             <button
//                               className="btn light btn-action dropdown-toggle"
//                               type="button"
//                               id={`dropdownMenuButton-${lead.id}`}
//                               data-bs-toggle="dropdown"
//                               aria-expanded="false"
//                             >
//                               <BsThreeDots size={20} />
//                             </button>
//                             <ul
//                               className="dropdown-menu"
//                               aria-labelledby={`dropdownMenuButton-${lead.id}`}
//                             >
//                               <li className="dropdown-item">
//                                 <button
//                                   className="btn view_btn btn-sm me-1"
//                                   onClick={() => handleViewLead(lead.id)}
//                                 >
//                                   <FaEye className="me-2" /> View
//                                 </button>
//                               </li>
//                               <li className="dropdown-item">
//                                 <button
//                                   className="btn edit_btn btn-sm me-1"
//                                   onClick={() => handleEditLead(lead.id)}
//                                 >
//                                   <FaEdit className="me-2" /> Edit
//                                 </button>
//                               </li>
//                               <li className="dropdown-item">
//                                 <button
//                                   className="btn btn-danger btn-sm"
//                                   onClick={() =>
//                                     handleRemarkList(
//                                       lead.id,
//                                       lead.order_id,
//                                       userId,
//                                     )
//                                   }
//                                 >
//                                   <FaEdit className="me-2" /> Remark History
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               )}

//               {/* PAGINATION */}
//               <div className="d-flex justify-content-end">
//                 <nav>
//                   <ul className="pagination">
//                     <li className="page-item">
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                       >
//                         <HiOutlineChevronLeft />
//                       </button>
//                     </li>
//                     {[...Array(totalPages)].map((_, index) => (
//                       <li key={index + 1} className="page-item">
//                         <button
//                           className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
//                           onClick={() => handlePageChange(index + 1)}
//                         >
//                           {index + 1}
//                         </button>
//                       </li>
//                     ))}
//                     <li className="page-item">
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                       >
//                         <HiChevronRight />
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* ===================== MODALS ===================== */}

//       {/* Add Remark Modal */}
//       <Modal
//         show={showResponseModal}
//         onHide={() => {
//           setShowResponseModal(false);
//           setDocumentFile([]);
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Remark</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleResponseSubmit}>
//             <Form.Group controlId="responseTextArea" className="mb-3">
//               <Form.Label>Remark Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={response}
//                 onChange={(e) => setResponse(e.target.value)}
//                 isInvalid={!!responseError}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {responseError}
//               </Form.Control.Feedback>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Documents</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*,.pdf"
//                 onChange={(e) => setDocumentFile(Array.from(e.target.files))}
//                 multiple
//               />
//               {documentFile && documentFile.length > 0 && (
//                 <div className="mt-2">
//                   <small className="text-muted">Selected files:</small>
//                   <ul className="list-unstyled">
//                     {documentFile.map((file, index) => (
//                       <li key={index}>
//                         <small>
//                           {file.name} ({Math.round(file.size / 1024)} KB)
//                         </small>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </Form.Group>

//             <div className="d-flex justify-content-end mt-3">
//               <Button
//                 variant="danger"
//                 onClick={() => {
//                   setShowResponseModal(false);
//                   setDocumentFile([]);
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="primary"
//                 type="submit"
//                 className="ms-2"
//                 disabled={!response && documentFile?.length === 0}
//               >
//                 Save Remark
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* View Modal */}
//       <Modal
//         show={showViewModal}
//         onHide={() => setShowViewModal(false)}
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Lead Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedLead && (
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <strong>Customer Name:</strong> {selectedLead.customer_name}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Mobile:</strong> {selectedLead.mobile}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Category:</strong> {selectedLead.category}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Service:</strong> {selectedLead.service}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Income Source:</strong> {selectedLead.income_source}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Adhar Number:</strong> {selectedLead.adhar_number}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Pan Card Number:</strong> {selectedLead.pan_card_number}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>State:</strong> {selectedLead.state_name}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>City:</strong> {selectedLead.city_name}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Monthly Income:</strong> {selectedLead.monthly_income}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Monthly EMI:</strong> {selectedLead.monthly_emi}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>CIBIL Score:</strong> {selectedLead.cibil_score}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>CIBIL Value:</strong> {selectedLead.cibil_score_value}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Required Loan:</strong>{" "}
//                 {selectedLead.require_loan_amount}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Pincode:</strong> {selectedLead.pincode}
//               </div>
//               <div className="col-md-6 mb-3">
//                 <strong>Location:</strong> {selectedLead.location}
//               </div>

//               <hr className="my-4" />
//               <h5 className="mb-3">Uploaded Documents</h5>
//               <div className="row">
//                 {[
//                   { label: "Adhar Front", key: "adhar_front_image", type: "img" },
//                   { label: "Adhar Back", key: "adhar_back_image", type: "img" },
//                   { label: "PAN Card", key: "pan_card_image", type: "img" },
//                   { label: "Current Residence Proof", key: "current_residence_proof", type: "pdf" },
//                   { label: "Bank Statement", key: "bank_statement", type: "pdf" },
//                   { label: "Bank Statement Current A/c", key: "bank_statement_current_account", type: "pdf" },
//                   { label: "GST Return", key: "gst_return", type: "pdf" },
//                   { label: "Property Paper", key: "property_paper", type: "pdf" },
//                   { label: "Permanent Address Proof", key: "permanent_address_proof", type: "pdf" },
//                   { label: "Employee/Business Proof", key: "employeeProof_bussinessRegistration", type: "pdf" },
//                   { label: "Salary Slip", key: "salary_slip", type: "pdf" },
//                   { label: "Form 16", key: "form16", type: "pdf" },
//                   { label: "ITR", key: "itr", type: "pdf" },
//                 ].map(({ label, key, type }) =>
//                   selectedLead[key] ? (
//                     <div className="col-md-4 mb-3" key={key}>
//                       <div className="mb-3">
//                         <strong>{label}:</strong>
//                         <br />
//                         {type === "img" ? (
//                           <>
//                             <img
//                               src={`${imageAPIURL}/loanlead/${selectedLead[key]}`}
//                               alt={label}
//                               className="img-fluid rounded mt-2"
//                               style={{
//                                 maxWidth: "200px",
//                                 maxHeight: "150px",
//                                 objectFit: "cover",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/200x150/cccccc/000000?text=No+Image";
//                               }}
//                             />
//                             <button
//                               className="ms-2 btn btn-primary"
//                               onClick={() =>
//                                 window.open(
//                                   `${imageAPIURL}/loanlead/${selectedLead[key]}`,
//                                   "_blank",
//                                 )
//                               }
//                             >
//                               Download
//                             </button>
//                           </>
//                         ) : (
//                           <a
//                             href={`${imageAPIURL}/loanlead/${selectedLead[key]}`}
//                             download
//                             className="ms-2 btn btn-primary mt-2"
//                           >
//                             Download
//                           </a>
//                         )}
//                       </div>
//                     </div>
//                   ) : null,
//                 )}
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={() => setShowViewModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={() => setShowEditModal(false)}
//         size="lg"
//         className="formselectnewdesign"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Loan Lead</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdateSubmit}>
//             <Row>
//               <Col md={12}>
//                 <div className="card_title_all mb-3">User Details</div>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Customer Name*</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="customer_name"
//                     value={editFormData.customer_name}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!errors.customer_name}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.customer_name}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Mobile*</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="mobile"
//                     value={editFormData.mobile}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.mobile}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.mobile}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Category</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="category"
//                     value={editFormData.category}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!errors.category}
//                   >
//                     <option value="">Select Category</option>
//                     {categoriesList.map((category) => (
//                       <option key={category.id} value={category.name}>
//                         {category.name}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Service</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="service"
//                     value={editFormData.service}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!errors.service}
//                   >
//                     <option value="">Select Service</option>
//                     {servicesList.map((service) => (
//                       <option key={service.id} value={service.name}>
//                         {service.name}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Income Source</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="income_source"
//                     value={editFormData.income_source}
//                     onChange={handleEditFormChange}
//                   >
//                     <option value="">Select Income Source</option>
//                     <option value="business">Business</option>
//                     <option value="salaried">Salaried</option>
//                     <option value="rent">Rent</option>
//                     <option value="pension">Pension</option>
//                     <option value="other">Other</option>
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Adhar Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="adhar_number"
//                     value={editFormData.adhar_number}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.adhar_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.adhar_number}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>PAN Card Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="pan_card_number"
//                     value={editFormData.pan_card_number}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.pan_card_number}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.pan_card_number}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>State</Form.Label>
//                   <Form.Select
//                     name="state"
//                     value={editFormData.state}
//                     onChange={handleEditFormChange}
//                     required
//                   >
//                     <option value="">Select State</option>
//                     {states.map((state) => (
//                       <option key={state.id} value={String(state.id)}>
//                         {state.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>City</Form.Label>
//                   <Form.Select
//                     name="city"
//                     value={editFormData.city}
//                     onChange={handleEditFormChange}
//                     required
//                     disabled={!editFormData.state || cities.length === 0}
//                   >
//                     <option value="">Select City</option>
//                     {cities.map((city) => (
//                       <option key={city.id} value={city.id}>
//                         {city.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Monthly Income</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="monthly_income"
//                     value={editFormData.monthly_income}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.monthly_income}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.monthly_income}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Monthly EMI</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="monthly_emi"
//                     value={editFormData.monthly_emi}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>CIBIL Score</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="cibil_score"
//                     value={editFormData.cibil_score}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>CIBIL Score Value</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="cibil_score_value"
//                     value={editFormData.cibil_score_value}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative mb-3">
//                   <Form.Label>Required Loan Amount</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="require_loan_amount"
//                     value={editFormData.require_loan_amount}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.require_loan_amount}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.require_loan_amount}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={6}>
//                 <Form.Group className="position-relative">
//                   <Form.Label>Pincode</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="pincode"
//                     value={editFormData.pincode}
//                     onChange={handleEditFormChange}
//                     isInvalid={!!validationErrors.pincode}
//                     required
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {validationErrors.pincode}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="position-relative">
//                   <Form.Label>Location</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="location"
//                     value={editFormData.location}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={12}>
//                 <div className="card_title_all mb-3">Document Uploads</div>
//               </Col>
//               {[
//                 { label: "Adhar Front Image", key: "adhar_front_image", accept: "image/*" },
//                 { label: "Adhar Back Image", key: "adhar_back_image", accept: "image/*" },
//                 { label: "PAN Card Image", key: "pan_card_image", accept: "image/*" },
//                 { label: "Current Residence Proof (PDF)", key: "current_residence_proof", accept: ".pdf" },
//                 { label: "Permanent Address Proof (PDF)", key: "permanent_address_proof", accept: ".pdf" },
//                 { label: "Employee/Business Registration Proof (PDF)", key: "employeeProof_bussinessRegistration", accept: ".pdf" },
//                 { label: "Bank Statement (PDF)", key: "bank_statement", accept: ".pdf" },
//                 { label: "Bank Statement - Current Account (PDF)", key: "bank_statement_current_account", accept: ".pdf" },
//                 { label: "GST Return (PDF)", key: "gst_return", accept: ".pdf" },
//                 { label: "Property Paper (PDF)", key: "property_paper", accept: ".pdf" },
//                 { label: "Salary Slip (PDF)", key: "salary_slip", accept: ".pdf" },
//                 { label: "ITR (PDF)", key: "itr", accept: ".pdf" },
//                 { label: "Form 16 (PDF)", key: "form16", accept: ".pdf" },
//               ].map(({ label, key, accept }) => (
//                 <Col md={6} key={key}>
//                   <Form.Group className="position-relative mb-3">
//                     <Form.Label>{label}</Form.Label>
//                     <Form.Control
//                       type="file"
//                       name={key}
//                       onChange={handleEditFileChange}
//                       accept={accept}
//                     />
//                     {editFormData[key] && (
//                       <div className="buttonviewallimages">
//                         <a
//                           href={`${imageAPIURL}/loanlead/${editFormData[key]}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           View Current File
//                         </a>
//                       </div>
//                     )}
//                   </Form.Group>
//                 </Col>
//               ))}
//             </Row>

//             <div className="d-flex justify-content-end mt-3">
//               <Button variant="danger" onClick={() => setShowEditModal(false)}>
//                 Cancel
//               </Button>
//               <Button variant="primary" type="submit" className="ms-2">
//                 Save Changes
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Confirmation Modal */}
//       <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this lead? This action cannot be undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={() => setShowConfirmModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDeleteLead}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Message Modal */}
//       <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
//         <Modal.Header
//           closeButton
//           className={`border-top border-4 ${
//             messageModalContent.type === "success"
//               ? "border-success"
//               : messageModalContent.type === "error"
//                 ? "border-danger"
//                 : "border-warning"
//           }`}
//         >
//           <Modal.Title
//             className={`modal-title ${
//               messageModalContent.type === "success"
//                 ? "text-success"
//                 : messageModalContent.type === "error"
//                   ? "text-danger"
//                   : "text-warning"
//             }`}
//           >
//             {messageModalContent.title}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-secondary">
//           <p>{messageModalContent.text}</p>
//         </Modal.Body>
//         <Modal.Footer className="justify-content-center">
//           <Button
//             variant={
//               messageModalContent.type === "success"
//                 ? "success"
//                 : messageModalContent.type === "error"
//                   ? "danger"
//                   : "primary"
//             }
//             onClick={closeCustomMessageModal}
//           >
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// }



// export default AllLoanList;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaDownload, FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;
const LIMIT = 10;

function AllLoanList() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [currentLeadId, setCurrentLeadId] = useState(null);
  const [response, setResponse] = useState("");
  const [responseError, setResponseError] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [documentFile, setDocumentFile] = useState([]);
  const [userId, setUserId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
  });
  const [editFormData, setEditFormData] = useState({
    id: "",
    customer_name: "",
    mobile: "",
    category: "",
    service: "",
    income_source: "",
    adhar_number: "",
    pan_card_number: "",
    state: "",
    city: "",
    monthly_income: "",
    monthly_emi: "",
    cibil_score: "",
    cibil_score_value: "",
    require_loan_amount: "",
    pincode: "",
    location: "",
    pan_card_image: "",
    adhar_front_image: "",
    adhar_back_image: "",
    current_residence_proof: "",
    permanent_address_proof: "",
    employeeProof_bussinessRegistration: "",
    bank_statement: "",
    bank_statement_current_account: "",
    gst_return: "",
    property_paper: "",
    salary_slip: "",
    itr: "",
    form16: "",
  });
  const [editFiles, setEditFiles] = useState({});
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState({
    name: "",
    orderid: "",
    mobile: "",
    category: "",
    service: "",
  });
  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const getAuthToken = () => localStorage.getItem("token");

  const showCustomMessageModal = (title, text, type) => {
    setMessageModalContent({ title, text, type });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => setShowMessageModal(false);

  // ═══════════════════════════════════════════
  // 🔹 FETCH STATES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const token = getAuthToken();
        if (!token) return;
        const response = await fetch(`${API_URL}/state-list`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch states.");
        const data = await response.json();
        setStates(data.data || []);
      } catch (err) {
        console.error("Fetch states error:", err);
      }
    };
    fetchStates();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH CITIES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchCities = async () => {
      if (editFormData.state) {
        try {
          const token = getAuthToken();
          if (!token) return;
          const response = await fetch(`${API_URL}/city-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ state_id: editFormData.state }),
          });
          if (!response.ok) throw new Error("Failed to fetch cities.");
          const data = await response.json();
          setCities(data.data || []);
        } catch (err) {
          console.error("Fetch cities error:", err);
        }
      } else {
        setCities([]);
      }
    };
    fetchCities();
  }, [editFormData.state]);

  // ═══════════════════════════════════════════
  // 🔹 FETCH CATEGORIES & SERVICES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchCategoriesAndServices = async () => {
      const token = getAuthToken();
      if (!token) return;

      try {
        const categoriesResponse = await fetch(
          `${API_URL}/loan-lead-category-list`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const categoriesData = await categoriesResponse.json();
        if (categoriesData.status === "1") {
          setCategoriesList(categoriesData.data);
        }

        const servicesResponse = await fetch(
          `${API_URL}/loan-lead-service-list`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const servicesData = await servicesResponse.json();
        if (servicesData.status === "1") {
          setServicesList(servicesData.data);
        }
      } catch (error) {
        console.error("Error fetching categories or services:", error);
      }
    };
    fetchCategoriesAndServices();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH LEADS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchLeads = async (page = 1) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Authentication token not found.");

      const query = new URLSearchParams({
        page,
        limit: LIMIT,
        name: searchTerm.name,
        orderid: searchTerm.orderid,
        mobile: searchTerm.mobile,
        category: searchTerm.category,
        service: searchTerm.service,
      }).toString();

      const response = await fetch(`${API_URL}/loan-lead-list?${query}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to fetch leads.");

      const result = await response.json();
      setLeads(result.data || []);

      const createrIds = (result.data || []).map((item) => item.creater_id);
      const validIds = createrIds.filter((id) => id != null);
      setUserId(validIds.length > 0 ? validIds[0] : null);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(result.totalPages) || 1;
      const total = Number(result.total) || (result.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(result.currentPage) || Number(page));
    } catch (error) {
      console.error("Error fetching loan leads:", error);
      showCustomMessageModal("Error", "Failed to fetch loan leads.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchLeads(pageNumber);
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    setCurrentPage(1);
    fetchLeads(1);
  };

  const handleClearSearch = () => {
    setSearchTerm({
      name: "",
      orderid: "",
      mobile: "",
      category: "",
      service: "",
    });
    setCurrentPage(1);
    setTimeout(() => fetchLeads(1), 0);
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH SINGLE LEAD
  // ═══════════════════════════════════════════
  const fetchSingleLead = async (id) => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/loan-lead-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });
      if (!response.ok) throw new Error("Failed to fetch lead details.");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching single lead:", error);
      showCustomMessageModal("Error", "Failed to fetch lead details.", "error");
      return null;
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW / EDIT
  // ═══════════════════════════════════════════
  const handleViewLead = async (id) => {
    const leadData = await fetchSingleLead(id);
    if (leadData) {
      setSelectedLead(leadData);
      setShowViewModal(true);
    }
  };

  const handleEditLead = async (id) => {
    const leadData = await fetchSingleLead(id);
    if (leadData) {
      setEditFormData({
        id: leadData.id,
        customer_name: leadData.customer_name,
        mobile: leadData.mobile,
        category: leadData.category,
        service: leadData.service,
        income_source: leadData.income_source,
        adhar_number: leadData.adhar_number,
        pan_card_number: leadData.pan_card_number,
        state: leadData.state,
        city: leadData.city,
        monthly_income: leadData.monthly_income,
        monthly_emi: leadData.monthly_emi,
        cibil_score: leadData.cibil_score,
        cibil_score_value: leadData.cibil_score_value,
        require_loan_amount: leadData.require_loan_amount,
        pincode: leadData.pincode,
        location: leadData.location,
        pan_card_image: leadData.pan_card_image || "",
        adhar_front_image: leadData.adhar_front_image || "",
        adhar_back_image: leadData.adhar_back_image || "",
        current_residence_proof: leadData.current_residence_proof || "",
        permanent_address_proof: leadData.permanent_address_proof || "",
        employeeProof_bussinessRegistration:
          leadData.employeeProof_bussinessRegistration || "",
        bank_statement: leadData.bank_statement || "",
        bank_statement_current_account:
          leadData.bank_statement_current_account || "",
        gst_return: leadData.gst_return || "",
        property_paper: leadData.property_paper || "",
        salary_slip: leadData.salary_slip || "",
        itr: leadData.itr || "",
        form16: leadData.form16 || "",
      });
      setShowEditModal(true);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditFileChange = (e) => {
    const { name, files } = e.target;
    setEditFiles((prev) => ({ ...prev, [name]: files[0] }));
  };

  const validateForm = () => {
    const errs = {};
    let isValid = true;

    if (!editFormData.customer_name) {
      errs.customer_name = "Customer name is required";
      isValid = false;
    }
    if (!editFormData.mobile) {
      errs.mobile = "Mobile number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(editFormData.mobile)) {
      errs.mobile = "Mobile number must be 10 digits";
      isValid = false;
    }
    if (
      editFormData.adhar_number &&
      !/^\d{12}$/.test(editFormData.adhar_number)
    ) {
      errs.adhar_number = "Aadhar number must be 12 digits";
      isValid = false;
    }
    if (
      editFormData.pan_card_number &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(editFormData.pan_card_number)
    ) {
      errs.pan_card_number = "Invalid PAN card format";
      isValid = false;
    }
    if (editFormData.pincode && !/^\d{6}$/.test(editFormData.pincode)) {
      errs.pincode = "Pincode must be 6 digits";
      isValid = false;
    }

    setErrors(errs);
    return isValid;
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const token = getAuthToken();
      const formPayload = new FormData();
      Object.keys(editFormData).forEach((key) => {
        formPayload.append(key, editFormData[key]);
      });
      Object.keys(editFiles).forEach((key) => {
        formPayload.append(key, editFiles[key]);
      });

      const response = await fetch(`${API_URL}/loan-lead-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formPayload,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update lead.");
      }

      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal("Success", "Lead updated successfully!", "success");
        setShowEditModal(false);
        fetchLeads(currentPage);
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      showCustomMessageModal("Error", "Failed to update lead.", "error");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 RESPONSE (ADD REMARK)
  // ═══════════════════════════════════════════
  const handleShowResponseModal = (leadId, orderId) => {
    setCurrentLeadId(leadId);
    setOrderId(orderId);
    setShowResponseModal(true);
  };

  const handleResponseSubmit = async (e) => {
    e.preventDefault();
    if (!response.trim()) {
      setResponseError("Response cannot be empty.");
      return;
    }
    try {
      const token = getAuthToken();
      const formData = new FormData();
      formData.append("lead_id", currentLeadId);
      formData.append("response", response);
      documentFile.forEach((file) => formData.append("documents", file));

      const res = await fetch(`${API_URL}/loan-lead-response-store`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!res.ok) throw new Error("Failed to store response.");
      setShowResponseModal(false);
      setResponse("");
      setResponseError("");
      setDocumentFile([]);
      fetchLeads(currentPage);
      showCustomMessageModal("Success", "Response added successfully!", "success");
    } catch (error) {
      console.error("Error storing response:", error);
      showCustomMessageModal("Error", "Failed to add response.", "error");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = async (id, newStatus) => {
    const originalLead = leads.find((lead) => lead.id === id);
    const originalStatus = originalLead?.status;

    try {
      setLeads((prev) =>
        prev.map((lead) =>
          lead.id === id ? { ...lead, status: newStatus } : lead
        )
      );

      const token = getAuthToken();
      if (!token) throw new Error("Authentication token not found");

      const response = await fetch(`${API_URL}/loan-lead-update-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id, status: newStatus }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update lead status");
      }

      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          result.message || "Lead status updated successfully",
          "success"
        );
        fetchLeads(currentPage);
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Status update error:", err);
      setLeads((prev) =>
        prev.map((lead) =>
          lead.id === id ? { ...lead, status: originalStatus } : lead
        )
      );
      showCustomMessageModal(
        "Error",
        err.message || "An error occurred while updating status",
        "error"
      );
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 HELPERS
  // ═══════════════════════════════════════════
  const formatStatus = (status) => {
    const statusMap = {
      new: "New",
      documentPending: "Document Pending",
      sanctionInProcess: "Sanction in Process",
      sanctioned: "Sanctioned",
      disbursementInProcess: "Disbursement in Process",
      disbursed: "Disbursed",
      propertyOriginalDocumentPending: "Property Original Document Pending",
      rejected: "Rejected",
      notintersted: "Not Interested",
    };
    return statusMap[status] || status;
  };

  const getStatusStyle = (status) => {
    const styles = {
      new: { bg: "#fef3e2", color: "#d97706" },
      documentPending: { bg: "#fef3e2", color: "#d97706" },
      sanctionInProcess: { bg: "#e8f1fb", color: "#1e5799" },
      sanctioned: { bg: "#e7f9eb", color: "#059669" },
      disbursementInProcess: { bg: "#e8f1fb", color: "#1e5799" },
      disbursed: { bg: "#e7f9eb", color: "#059669" },
      propertyOriginalDocumentPending: { bg: "#fef3e2", color: "#d97706" },
      rejected: { bg: "#feeaeb", color: "#dc2626" },
      notintersted: { bg: "#f1f5f9", color: "#64748b" },
    };
    return styles[status] || { bg: "#f1f5f9", color: "#64748b" };
  };

  const handleRemarkList = (leadId, orderid, userId) => {
    navigate(`/loan-remarks/${leadId}/${orderid}/${userId}`);
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT
  // ═══════════════════════════════════════════
  const exportAllToExcel = async () => {
    setExporting(true);
    try {
      const token = getAuthToken();
      if (!token) {
        alert("Please login!");
        return;
      }
      const response = await fetch(`${API_URL}/loan-lead-exceldownload`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/csv",
        },
      });
      if (!response.ok) {
        alert("Server Error: Unable to download!");
        return;
      }
      const csvData = await response.text();
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `loan_leads_${Date.now()}.csv`);
      link.click();
    } catch (error) {
      console.error("CSV Export Error:", error);
      alert("Export Failed! Try again");
    } finally {
      setExporting(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading && leads.length === 0) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                📋
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Loan Lead List
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all loan leads in one place ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={exportAllToExcel}
                disabled={exporting}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: exporting ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                }}
              >
                <FaDownload /> {exporting ? "Exporting..." : "Export"}
              </button>

              <Link
                to="/create-loan"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Create Lead
              </Link>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={searchTerm.name}
                    onChange={(e) =>
                      setSearchTerm({
                        ...searchTerm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Loan ID</label>
                  <input
                    type="text"
                    name="orderid"
                    placeholder="Loan ID"
                    value={searchTerm.orderid}
                    onChange={(e) =>
                      setSearchTerm({
                        ...searchTerm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile number"
                    value={searchTerm.mobile}
                    onChange={(e) =>
                      setSearchTerm({
                        ...searchTerm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    style={inputStyle}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Category</label>
                  <select
                    name="category"
                    value={searchTerm.category}
                    onChange={(e) =>
                      setSearchTerm({
                        ...searchTerm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    style={inputStyle}
                  >
                    <option value="">All Categories</option>
                    {categoriesList.map((category) => (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ flex: 1, minWidth: "150px" }}>
                  <label style={labelStyle}>Service</label>
                  <select
                    name="service"
                    value={searchTerm.service}
                    onChange={(e) =>
                      setSearchTerm({
                        ...searchTerm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    style={inputStyle}
                  >
                    <option value="">All Services</option>
                    {servicesList.map((service) => (
                      <option key={service.id} value={service.name}>
                        {service.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    type="button"
                    onClick={handleSearch}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1200px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Lead ID",
                      "Customer Name",
                      "Mobile",
                      "Category",
                      "Service",
                      "Status",
                      "Lead Date",
                      "Remark",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {leads?.length > 0 ? (
                    leads.map((lead, i) => (
                      <tr
                        key={lead.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + i + 1}
                        </td>
                        <td style={cellText}>{lead.order_id}</td>
                        <td style={cellDark}>
                          {lead.customer_name
                            ? lead.customer_name.charAt(0).toUpperCase() +
                              lead.customer_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{lead.mobile || "-"}</td>
                        <td style={cellGray}>
                          {lead.category
                            ? lead.category.charAt(0).toUpperCase() +
                              lead.category.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>
                          {lead.service
                            ? lead.service.charAt(0).toUpperCase() +
                              lead.service.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <select
                            value={lead.status}
                            onChange={(e) =>
                              handleStatusUpdate(lead.id, e.target.value)
                            }
                            disabled={loading}
                            style={{
                              padding: "6px 12px",
                              borderRadius: "20px",
                              border: "none",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              cursor: "pointer",
                              background: getStatusStyle(lead.status).bg,
                              color: getStatusStyle(lead.status).color,
                              outline: "none",
                              minWidth: "170px",
                            }}
                          >
                            {[
                              "new",
                              "documentPending",
                              "sanctionInProcess",
                              "sanctioned",
                              "disbursementInProcess",
                              "disbursed",
                              "propertyOriginalDocumentPending",
                              "rejected",
                              "notintersted",
                            ].map((status) => (
                              <option key={status} value={status}>
                                {formatStatus(status)}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {lead.date || "-"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <button
                            onClick={() =>
                              handleShowResponseModal(lead.id, lead.order_id)
                            }
                            style={{
                              padding: "7px 14px",
                              borderRadius: "8px",
                              border: "none",
                              background:
                                "linear-gradient(135deg, #059669, #047857)",
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              boxShadow: "0 4px 12px rgba(5, 150, 105, 0.25)",
                            }}
                          >
                            Add Remark
                          </button>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleViewLead(lead.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleEditLead(lead.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Lead
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleRemarkList(
                                      lead.id,
                                      lead.order_id,
                                      userId
                                    )
                                  }
                                  style={{ ...dropdownItem, color: "#7c3aed" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#f3e8ff";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#f3e8ff", "#7c3aed")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Remark History
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="10"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No loan leads found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📋 Loan Lead Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {selectedLead && (
            <>
              <h6 style={sectionHeader}>👤 Customer Details</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <strong style={labelColor}>Customer Name:</strong>
                  <p style={textDark}>{selectedLead.customer_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Mobile:</strong>
                  <p style={textDark}>{selectedLead.mobile || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Category:</strong>
                  <p style={textDark}>{selectedLead.category || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Service:</strong>
                  <p style={textDark}>{selectedLead.service || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Income Source:</strong>
                  <p style={textDark}>{selectedLead.income_source || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Aadhaar Number:</strong>
                  <p style={textDark}>{selectedLead.adhar_number || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>PAN Card:</strong>
                  <p style={textDark}>{selectedLead.pan_card_number || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>State:</strong>
                  <p style={textDark}>{selectedLead.state_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>City:</strong>
                  <p style={textDark}>{selectedLead.city_name || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Monthly Income:</strong>
                  <p style={textDark}>{selectedLead.monthly_income || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Monthly EMI:</strong>
                  <p style={textDark}>{selectedLead.monthly_emi || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>CIBIL Score:</strong>
                  <p style={textDark}>{selectedLead.cibil_score || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>CIBIL Value:</strong>
                  <p style={textDark}>{selectedLead.cibil_score_value || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Required Loan:</strong>
                  <p style={textDark}>
                    {selectedLead.require_loan_amount || "-"}
                  </p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Pincode:</strong>
                  <p style={textDark}>{selectedLead.pincode || "-"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Location:</strong>
                  <p style={textDark}>{selectedLead.location || "-"}</p>
                </Col>
              </Row>

              <hr
                style={{
                  margin: "20px 0",
                  border: "none",
                  borderTop: "1.5px dashed #e2e8f0",
                }}
              />
              <h6 style={sectionHeader}>📷 Uploaded Documents</h6>
              <Row>
                {[
                  {
                    label: "Aadhaar Front",
                    key: "adhar_front_image",
                    type: "img",
                  },
                  {
                    label: "Aadhaar Back",
                    key: "adhar_back_image",
                    type: "img",
                  },
                  { label: "PAN Card", key: "pan_card_image", type: "img" },
                  {
                    label: "Current Residence Proof",
                    key: "current_residence_proof",
                    type: "pdf",
                  },
                  {
                    label: "Bank Statement",
                    key: "bank_statement",
                    type: "pdf",
                  },
                  {
                    label: "Bank Statement Current A/c",
                    key: "bank_statement_current_account",
                    type: "pdf",
                  },
                  { label: "GST Return", key: "gst_return", type: "pdf" },
                  {
                    label: "Property Paper",
                    key: "property_paper",
                    type: "pdf",
                  },
                  {
                    label: "Permanent Address Proof",
                    key: "permanent_address_proof",
                    type: "pdf",
                  },
                  {
                    label: "Employee/Business Proof",
                    key: "employeeProof_bussinessRegistration",
                    type: "pdf",
                  },
                  { label: "Salary Slip", key: "salary_slip", type: "pdf" },
                  { label: "Form 16", key: "form16", type: "pdf" },
                  { label: "ITR", key: "itr", type: "pdf" },
                ].map(({ label, key, type }) =>
                  selectedLead[key] ? (
                    <Col md={4} key={key} className="mb-3">
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "8px",
                        }}
                      >
                        {label}
                      </p>
                      {type === "img" ? (
                        <a
                          href={`${imageAPIURL}/loanlead/${selectedLead[key]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${imageAPIURL}/loanlead/${selectedLead[key]}`}
                            alt={label}
                            style={{
                              width: "100%",
                              maxHeight: "150px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "1.5px solid #e2e8f0",
                              cursor: "pointer",
                            }}
                            onError={(e) => {
                              e.target.src =
                                "https://placehold.co/300x200/cccccc/666666?text=No+Image";
                            }}
                          />
                        </a>
                      ) : (
                        <a
                          href={`${imageAPIURL}/loanlead/${selectedLead[key]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "8px 14px",
                            borderRadius: "8px",
                            background: "#feeaeb",
                            color: "#dc2626",
                            fontSize: "12px",
                            fontWeight: "700",
                            textDecoration: "none",
                          }}
                        >
                          📄 Download
                        </a>
                      )}
                    </Col>
                  ) : null
                )}
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={() => setShowViewModal(false)}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "8px 24px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        size="lg"
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Loan Lead
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdateSubmit}>
            <h6 style={sectionHeader}>👤 User Details</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Customer Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="customer_name"
                    value={editFormData.customer_name}
                    onChange={handleEditFormChange}
                    isInvalid={!!errors.customer_name}
                    required
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.customer_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Mobile*</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={editFormData.mobile}
                    onChange={handleEditFormChange}
                    isInvalid={!!errors.mobile}
                    required
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.mobile}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Category</Form.Label>
                  <Form.Select
                    name="category"
                    value={editFormData.category}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="">Select Category</option>
                    {categoriesList.map((category) => (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Service</Form.Label>
                  <Form.Select
                    name="service"
                    value={editFormData.service}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="">Select Service</option>
                    {servicesList.map((service) => (
                      <option key={service.id} value={service.name}>
                        {service.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Income Source</Form.Label>
                  <Form.Select
                    name="income_source"
                    value={editFormData.income_source}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="">Select Income Source</option>
                    <option value="business">Business</option>
                    <option value="salaried">Salaried</option>
                    <option value="rent">Rent</option>
                    <option value="pension">Pension</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Aadhaar Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="adhar_number"
                    value={editFormData.adhar_number}
                    onChange={handleEditFormChange}
                    isInvalid={!!errors.adhar_number}
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.adhar_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>PAN Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="pan_card_number"
                    value={editFormData.pan_card_number}
                    onChange={handleEditFormChange}
                    isInvalid={!!errors.pan_card_number}
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pan_card_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>State</Form.Label>
                  <Form.Select
                    name="state"
                    value={editFormData.state}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.id} value={String(state.id)}>
                        {state.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>City</Form.Label>
                  <Form.Select
                    name="city"
                    value={editFormData.city}
                    onChange={handleEditFormChange}
                    disabled={!editFormData.state || cities.length === 0}
                    style={inputStyle}
                  >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Monthly Income</Form.Label>
                  <Form.Control
                    type="text"
                    name="monthly_income"
                    value={editFormData.monthly_income}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Monthly EMI</Form.Label>
                  <Form.Control
                    type="text"
                    name="monthly_emi"
                    value={editFormData.monthly_emi}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>CIBIL Score</Form.Label>
                  <Form.Control
                    type="text"
                    name="cibil_score"
                    value={editFormData.cibil_score}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>CIBIL Score Value</Form.Label>
                  <Form.Control
                    type="text"
                    name="cibil_score_value"
                    value={editFormData.cibil_score_value}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>
                    Required Loan Amount
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="require_loan_amount"
                    value={editFormData.require_loan_amount}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    name="pincode"
                    value={editFormData.pincode}
                    onChange={handleEditFormChange}
                    isInvalid={!!errors.pincode}
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.pincode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Location</Form.Label>
                  <Form.Control
                    type="text"
                    name="location"
                    value={editFormData.location}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr
              style={{
                margin: "20px 0",
                border: "none",
                borderTop: "1.5px dashed #e2e8f0",
              }}
            />
            <h6 style={sectionHeader}>📷 Document Uploads</h6>

            <Row>
              {[
                {
                  label: "Aadhaar Front Image",
                  key: "adhar_front_image",
                  accept: "image/*",
                },
                {
                  label: "Aadhaar Back Image",
                  key: "adhar_back_image",
                  accept: "image/*",
                },
                {
                  label: "PAN Card Image",
                  key: "pan_card_image",
                  accept: "image/*",
                },
                {
                  label: "Current Residence Proof (PDF)",
                  key: "current_residence_proof",
                  accept: ".pdf",
                },
                {
                  label: "Permanent Address Proof (PDF)",
                  key: "permanent_address_proof",
                  accept: ".pdf",
                },
                {
                  label: "Employee/Business Registration Proof (PDF)",
                  key: "employeeProof_bussinessRegistration",
                  accept: ".pdf",
                },
                {
                  label: "Bank Statement (PDF)",
                  key: "bank_statement",
                  accept: ".pdf",
                },
                {
                  label: "Bank Statement - Current Account (PDF)",
                  key: "bank_statement_current_account",
                  accept: ".pdf",
                },
                {
                  label: "GST Return (PDF)",
                  key: "gst_return",
                  accept: ".pdf",
                },
                {
                  label: "Property Paper (PDF)",
                  key: "property_paper",
                  accept: ".pdf",
                },
                {
                  label: "Salary Slip (PDF)",
                  key: "salary_slip",
                  accept: ".pdf",
                },
                { label: "ITR (PDF)", key: "itr", accept: ".pdf" },
                { label: "Form 16 (PDF)", key: "form16", accept: ".pdf" },
              ].map(({ label, key, accept }) => (
                <Col md={6} key={key}>
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>{label}</Form.Label>
                    <Form.Control
                      type="file"
                      name={key}
                      onChange={handleEditFileChange}
                      accept={accept}
                      style={inputStyle}
                    />
                    {editFormData[key] && (
                      <Form.Text>
                        <a
                          href={`${imageAPIURL}/loanlead/${editFormData[key]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#1e5799",
                            fontWeight: "600",
                            fontSize: "11.5px",
                          }}
                        >
                          👁 View Current File
                        </a>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              Save Changes
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 ADD REMARK MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showResponseModal}
        onHide={() => {
          setShowResponseModal(false);
          setDocumentFile([]);
        }}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            💬 Add Remark
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <Form onSubmit={handleResponseSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Remark Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={response}
                onChange={(e) => setResponse(e.target.value)}
                isInvalid={!!responseError}
                style={{ ...inputStyle, resize: "vertical" }}
              />
              <Form.Control.Feedback type="invalid">
                {responseError}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Documents</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => setDocumentFile(Array.from(e.target.files))}
                multiple
                style={inputStyle}
              />
              {documentFile && documentFile.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <small
                    style={{
                      color: "#64748b",
                      fontWeight: "600",
                      fontSize: "11.5px",
                    }}
                  >
                    Selected files:
                  </small>
                  <ul
                    style={{
                      marginTop: "6px",
                      paddingLeft: "18px",
                      marginBottom: 0,
                    }}
                  >
                    {documentFile.map((file, index) => (
                      <li
                        key={index}
                        style={{ fontSize: "12px", color: "#334155" }}
                      >
                        {file.name} ({Math.round(file.size / 1024)} KB)
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={!response && documentFile?.length === 0}
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              Save Remark
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                {messageModalContent.text}
              </div>
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                <button
                  type="button"
                  onClick={closeCustomMessageModal}
                  style={{
                    padding: "10px 22px",
                    borderRadius: "10px",
                    border: "none",
                    background: "#1e5799",
                    color: "#ffffff",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };

const sectionHeader = {
  fontWeight: "800",
  color: "#1e5799",
  marginBottom: "14px",
  fontSize: "15px",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = { padding: "12px", fontWeight: "600", color: "#1e5799" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default AllLoanList;